import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/utils/local-storage.service';
import commonLogics from 'src/app/utils/common-logic.service';
import constant from 'src/app/app.constant';
import * as moment from 'moment'

@Component({
  selector: 'app-rider-qr-code',
  templateUrl: './rider-qr-code.component.html',
  styleUrls: ['./rider-qr-code.component.scss']
})
export class RiderQrCodeComponent implements OnInit {
  public openMessageBox: boolean = false;
  public commonLogics: any = commonLogics;
  public qrdata: string = 'true';
  constructor(public localData: LocalStorageService) { }

  ngOnInit(): void {
    let vendorUserId = this.localData.getItem(constant.localStorage.user_id)
    let currentDate = moment(new Date()).add(9, 'minutes').format(constant.DateFormatServerSideDate);

    const originalString: any = vendorUserId + '_' + currentDate;
    this.qrdata = btoa(originalString);
  }
  toggleMessageBox() {
    this.openMessageBox = !this.openMessageBox;
  }
}
